import React from 'react';
import { ClockIcon, ShieldCheckIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 px-4 relative overflow-hidden bg-navy-950 border-y border-navy-800" data-id="element-334">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoMjU1LCAyNTUsIDI1NSwgMC4wNSkiLz48L3N2Zz4=')] opacity-30" data-id="element-335"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-336">
        <div className="glass-card border-patriot-red/30 p-8 md:p-12 rounded-2xl shadow-[0_20px_60px_rgba(178,34,52,0.1)] relative" data-id="element-337">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-red-gradient text-white font-bold px-6 py-2 rounded-full flex items-center gap-2 shadow-lg uppercase tracking-wider text-sm" data-id="element-338">
            <ShieldCheckIcon className="w-4 h-4" data-id="element-339" />
            Guaranteed Results
          </div>

          <div className="flex flex-col items-center text-center gap-4 mb-8 mt-4" data-id="element-340">
            <div className="w-16 h-16 rounded-full bg-patriot-red/10 border border-patriot-red/30 flex items-center justify-center" data-id="element-341">
              <ClockIcon className="w-8 h-8 text-patriot-red" data-id="element-342" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white font-serif" data-id="element-343">
              Transformation in 48 Hours
            </h2>
            <p className="text-lg text-slate-300 max-w-2xl leading-relaxed" data-id="element-344">
              After reading this exclusive manifesto, you will experience a
              radical shift in your perception of reality:
            </p>
          </div>

          <div className="space-y-5 max-w-3xl mx-auto" data-id="element-345">
            <div className="flex gap-6 items-start" data-id="element-346">
              <div className="w-1.5 h-full min-h-[4rem] bg-red-gradient rounded-full flex-shrink-0 mt-1" data-id="element-347"></div>
              <p className="text-xl text-slate-400 leading-relaxed" data-id="element-348">
                <strong className="text-white" data-id="element-349">Absolute Clarity:</strong> You
                will feel absolute clarity about the media noise. You'll be able
                to see through the prefabricated narratives instantly.
              </p>
            </div>

            <div className="flex gap-6 items-start" data-id="element-350">
              <div className="w-1.5 h-full min-h-[4rem] bg-red-gradient rounded-full flex-shrink-0 mt-1" data-id="element-351"></div>
              <p className="text-xl text-slate-400 leading-relaxed" data-id="element-352">
                <strong className="text-white" data-id="element-353">Immunity to Fear:</strong> The
                fear of being "canceled" or socially criticized will disappear
                because you'll understand that their only power is your consent.
              </p>
            </div>

            <div className="flex gap-6 items-start" data-id="element-354">
              <div className="w-1.5 h-full min-h-[4rem] bg-red-gradient rounded-full flex-shrink-0 mt-1" data-id="element-355"></div>
              <p className="text-xl text-slate-400 leading-relaxed" data-id="element-356">
                <strong className="text-white" data-id="element-357">Natural Leadership:</strong> You
                will become an unbreakable reference point of integrity and
                courage for your family and friends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}